import { createSlice } from "@reduxjs/toolkit";
import {
  generateReportThunk,
  generateXarReportThunk,
  listXarReportThunk,
  resolveAddressThunk
} from "./reportsActions";

export interface IReportsFilterData {
  startDate?: string;
  endDate?: string;
  object?: string[];
  objectType?: string[];
  group?: string[];
  key?: string[];
  daysOfWeek?: number[];
  startTime?: string;
  endTime?: string;
  reportType?: number;
  rideModes?: number[];
  startedWithoutIgnition?: boolean;
}

export interface IReportsDateValues {
  startDate: string;
  endDate: string;
}

export interface IReportsFilterData {
  startDate?: string;
  endDate?: string;
  object?: string[];
  objectType?: string[];
  group?: string[];
  key?: string[];
  daysOfWeek?: number[];
  startTime?: string;
  endTime?: string;
  reportType?: number;
  rideModes?: number[];
  startedWithoutIgnition?: boolean;
  [key: string]: any;
}

export interface IReportsDateValues {
  startDate: string;
  endDate: string;
}

export interface IReportsState {
  loading: boolean;
  resolvedAddressLoading: boolean;
  report: Array<any>;
  xarReport: Array<any>;
  xarReportLoading: boolean;
  resolvedAddresses: Array<any>;
  reportsFilterData: IReportsFilterData;
  hasExceededLimit: boolean | null;
  reportsDateValues: IReportsDateValues;
}

const initialState: IReportsState = {
  loading: false,
  resolvedAddressLoading: false,
  report: [],
  xarReport: [],
  xarReportLoading: false,
  resolvedAddresses: [],
  reportsFilterData: {},
  reportsDateValues: {
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString()
  },
  hasExceededLimit: null
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    resetReports: (state) => {
      state.report = [];
      state.loading = false;
      state.hasExceededLimit = null;
      state.xarReport = [];
      state.xarReportLoading = false;
    },
    setReportsFilterData: (state, action) => {
      state.reportsFilterData = action.payload;
    },
    setReportsDateValues: (state, action) => {
      state.reportsDateValues = {
        startDate:
          action.payload.startDate instanceof Date
            ? action.payload.startDate.toISOString()
            : action.payload.startDate,
        endDate:
          action.payload.endDate instanceof Date
            ? action.payload.endDate.toISOString()
            : action.payload.endDate
      };
    }
  },
  extraReducers: (builder) => {
    // Get Reports Action Cases
    builder.addCase(generateReportThunk.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(generateReportThunk.fulfilled, (state, action: any) => {
      state.report = action.payload.data;
      state.hasExceededLimit = action.payload.hasExceededLimit;
      state.loading = false;
    });
    builder.addCase(generateReportThunk.rejected, (state) => {
      state.loading = false;
    });

    //list Xar reports
    builder.addCase(listXarReportThunk.pending, (state) => {
      state.xarReportLoading = true;
    });
    builder.addCase(listXarReportThunk.fulfilled, (state, action: any) => {
      state.xarReport = action.payload.items;
      state.xarReportLoading = false;
    });
    builder.addCase(listXarReportThunk.rejected, (state) => {
      state.xarReportLoading = false;
    });

    //generate Xar reports
    builder.addCase(generateXarReportThunk.pending, (state) => {
      state.xarReportLoading = true;
    });
    builder.addCase(generateXarReportThunk.fulfilled, (state, action: any) => {
      // state.xarReport = action.payload.data;
      state.xarReportLoading = false;
    });
    builder.addCase(generateXarReportThunk.rejected, (state) => {
      state.xarReportLoading = false;
    });

    builder.addCase(resolveAddressThunk.pending, (state) => {
      state.resolvedAddressLoading = true;
    });
    builder.addCase(resolveAddressThunk.fulfilled, (state, action: any) => {
      state.resolvedAddresses = [
        ...state.resolvedAddresses,
        {
          latitude: action.meta.arg.latitude,
          longitude: action.meta.arg.longitude,
          address: action.payload.resolvedAddress
        }
      ];
      state.resolvedAddressLoading = false;
    });
    builder.addCase(resolveAddressThunk.rejected, (state) => {
      state.resolvedAddressLoading = false;
    });
  }
});

export * from "./reportsActions";
export const { resetReports, setReportsFilterData, setReportsDateValues } =
  reportsSlice.actions;
export default reportsSlice.reducer;
